import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import { ShortTextInput } from '~/@/components/inputs/text/short-text-input'

export type CustomFilterInputProps = GridFilterInputValueProps & { disabled: boolean }

/**
 * Wrapper component for Input to handle MUI Grid filter props
 */
export function CustomFilterInput(props: CustomFilterInputProps) {
  const { item, applyValue, disabled } = props

  return (
    <ShortTextInput
      className="h-9 text-xs"
      disabled={disabled}
      onChange={(event) => {
        const value = event.target.value
        applyValue({ ...item, value })
      }}
      value={item.value ?? ''}
    />
  )
}
